// @ts-nocheck
import React from 'react';

const NovosilkaPage = () => {
  return (
    <section className="pt-6 pb-10">
      <div className="container md:px-[65px]">
        <div className="flex flex-col-reverse md:flex-row">
          <div className="relative md:w-2/5  md:h-[500px]">
            <h2 className="md:mt-3 flex py-3  px-4 md:px-6 text-2xl md:text-3xl font-bold text-start uppercase bg-[#A81414] md:h-[120px] items-center text-white max-md:rounded-br-xl rounded-bl-xl md:rounded-tl-xl">
              Духовно-відпустовий центр "Святе джерело", с. Новосілка, Львівський район
            </h2>
            <div class="max-md:hidden mt-3 absolute md:-right-[90px] z-10  max-md:right-[60px] border-[#A81414] md:top-0
              w-0 h-0
              border-t-[60px] border-b-[60px] border-l-[30px]
              border-t-transparent border-b-transparent border-l-red-600">
            </div>
            <div class="hidden  absolute bottom-0 md:left-0 md:-translate-y-1/2 border-[#A81414]
              w-0 h-0
              border-b-[30px] border-l-[calc(50vw-20px)] border-r-[calc(50vw-20px)]
              md:border-t-[200px] md:border-b-[200px] md:border-l-[100px]
              border-l-transparent border-r-transparent border-t-transparent border-t-red-600">
            </div>
            <div
              // @ts-ignore
              className="flex flex-col py-4 pl-4 text-base md:text-lg md:px-8">
              <div className="pt-4 md:px-6 text-lg md:text-xl font-bold text-[#A81414]">
                Відповідальний:
              </div>
              <div className="pb-2 md:px-6 text-lg md:text-xl font-bold text-[#A81414]">
                Парох о. Олег Федоренко, СДБ
              </div>
              <div className="md:px-6 text-lg md:text-xl font-bold text-[#A81414]">
                Контактний номер:
              </div>
              <div className="md:px-6 text-lg md:text-xl font-bold text-[#A81414]">
                +380 97 121 07 63.
              </div>
            </div>
          </div>
          <div className="relative md:w-3/5">
             <div class="md:hidden block absolute bottom-0 md:left-0 md:-translate-y-1/2 border-[#A81414]
              w-0 h-0
              border-b-[30px] border-l-[calc(50vw-20px)] border-r-[calc(50vw-20px)]
              md:border-t-[200px] md:border-b-[200px] md:border-l-[100px]
              border-l-transparent border-r-transparent border-t-transparent border-t-red-600">
            </div>
            <div class="max-md:hidden md:block mt-3 top-0 absolute z-10 max-md:right-0 md:left-0 bg-[#A81414] h-[120px] w-[60px]">
            </div>
            <img
              className="max-md:h-[288px] md:h-[500px] object-cover object-right w-full max-md:rounded-t-xl md:rounded-xl"
              src="/images/skhidnytsya2.jpg"
              alt=""
            />
          </div>
        </div>
      </div>
    </section>
    // <section className="pt-6 pb-10">
    //   <div className="container px-[65px]">
    //     <div className="flex ">

    //       <div className="relative w-2/5  h-[500px]">
    //         <h2 className="mt-3 flex py-3 px-6 text-3xl font-bold text-start uppercase bg-[#A81414] h-[120px] items-center text-white rounded-tl-xl rounded-bl-xl">
    //           Духовно-Відпустовий центр с. Новосілка (Львівська область)
    //         </h2>

    //         <div
    //           // @ts-ignore
    //           className="flex flex-col px-8 py-4 text-lg">


    //           <div className="pt-4 px-4 text-xl font-bold text-[#A81414]">
    //             Відповідальний:
    //           </div>
    //           <div className="pb-4 px-4 text-xl font-bold text-[#A81414]">
    //             Парох о. Олег Федоренко, СДБ
    //           </div>
    //           <div className="px-4 text-xl font-bold text-[#A81414]">
    //             Контактний номер: 
    //           </div>
    //           <div className="px-4 text-xl font-bold text-[#A81414]">
    //             +380 97 121 07 63
    //           </div>
    //         </div>
    //       </div>
    //       <div className="relative w-3/5">
    //         <div class="mt-3 absolute left-[60px] border-[#A81414]
    //           w-0 h-0
    //           border-t-[60px] border-b-[60px] border-l-[30px]
    //           border-t-transparent border-b-transparent border-l-red-600">
    //         </div>
    //         <div class="mt-3 absolute left-0 bg-[#A81414] h-[120px] w-[60px]">
    //         </div>
    //         <img
    //           className="h-[500px] object-cover w-full rounded-xl"
    //           src="/images/skhidnytsya2.jpg"
    //           alt=""
    //         />
    //       </div>
    //     </div>
    //   </div>
    // </section>
  );
};

export default NovosilkaPage;
